import { CartPropertiesEffects } from "./cart-properties.effect";
import { CoursesEffects } from "./courses.effect";


export const effects: any[] = [
    CoursesEffects,
    CartPropertiesEffects
];

export * from "./courses.effect";
export * from "./cart-properties.effect";
